import DATATABLE_TRANSLATIONS from "./datatable_translations";

export default class EducationsDataTable {
  constructor() {
    $(document).ready(function() {
      showEducationsTable();
    });

    $(document).on("turbo:render", function() {
      showEducationsTable();
    });

    function showEducationsTable() {
      $('#educations-datatable').dataTable({
        "order": [],
        "columnDefs": [ {
          "targets"  : 'no-sort',
          "orderable": false,
        }],
        "language": DATATABLE_TRANSLATIONS,
        "processing": true,
        "serverSide": true,
        "ajax": {
          "url": $('#educations-datatable').data('source')
        },
        "pagingType": "full_numbers",
        "columns": [
          {"data": "isced"},
          {"data": "name"},
          {"data": "active"},
          {"data": "actions"}
        ]
        // pagingType is optional, if you want full pagination controls.
        // Check dataTables documentation to learn more about
        // available options.
      });
    }
  }
}
